import { btn } from "@/ui/btn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";

export function randomBtn(parent) {
  const elem = btn({
    text: "Random game",
    parent: parent,
    classes: ["random", "btn", "level-bar__item"],
    onClick: () => eventEmitter.emit("randomGame"),
  });
  return elem;
}
